import { type UiTone } from '@/theme/uiTokens';
import { StatusBanner } from './StatusBanner';
import type { ReactElement } from 'react';

type InlineErrorProps = { tone?: UiTone; message: string };

export const InlineError = ({ tone = 'red', message }: InlineErrorProps): ReactElement => {
  if (!message) return <></>;
  return <StatusBanner tone={tone} message={message} variant="outlined" dense={true} />;
};
